(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cts-control-kits-test"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-cts-info]');
  if (!link) return;
  const section = link.closest('.cts-control-kits');
  if (!section) return;
  const details = section.querySelector('#cts-kit-detail-' + link.dataset.ctsInfo);
  if (!details) return;
  event.preventDefault();
  details.hidden = false;
  details.open = true;
  details.scrollIntoView({behavior:'smooth',block:'start'});
  details.querySelector('summary').focus({preventScroll:true});
});
document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement) || !details.closest('.cts-kit-information')) return;
  if (!details.open) {
    details.hidden = true;
    const section = details.closest('.cts-control-kits');
    const trigger = section.querySelector('[data-cts-info="' + details.id.replace('cts-kit-detail-', '') + '"]');
    if (trigger) trigger.focus({preventScroll:true});
  }
}, true);
  } catch(e) { console.error(e); }
})();

})();
